import React, { useRef, useEffect } from "react";
import { SelectPicker, Input } from 'rsuite';
import countries from "config/country.json";
import flagIcons from "config/countryflag.json"
import 'rsuite/dist/rsuite.min.css';

const TelephoneInput = (props) => {
    // const countries = jsonData.countries;
    // const flagIcons = jsonDataFlag;
    // const [countryValue, setCountryValue] = useState('');
    
    // Handle ResizeObserver error
    useEffect(() => {
        const handleResizeObserverError = (e) => {
            if (e.message === 'ResizeObserver loop limit exceeded') {
                e.stopImmediatePropagation();
            }
        };
        
        window.addEventListener('error', handleResizeObserverError);
        
        return () => {
            window.removeEventListener('error', handleResizeObserverError);
        };
    }, []);
    
    let data = countries.map((country, index) => {
        return {
            label:
                <div className={`d-flex gap-10 align-items-center country-flag-content`}>
                    <span className="country-flag-icon" dangerouslySetInnerHTML={{ __html: flagIcons[country.flag] }}></span>
                    <span className="text-12 text-dark font-weight-500">
                        {country.name}
                        <span className="text-12 font-weight-400 country-code"> {country.dialCode}</span>
                    </span>
                </div>,
            value: country.code.toLowerCase(),
            dialCode: country.dialCode.split('+')[1],
            name: country.name,
            flag: country.flag,
            code:
                <div className={`d-flex align-items-center gap-5 ${props.flagClass}`}>
                    <span className="my-auto country-flag-icon" dangerouslySetInnerHTML={{ __html: flagIcons[country.flag] }}></span>
                    <span className="my-auto">{country.dialCode}</span>
                </div>,
            key: index
        }
    })

    const mountRef = useRef(null);

    return <div ref={mountRef} className={"telephone-wrapper d-flex align-items-center " + props.className} id={props.id || ''}>
        <div className="country-select">
            <SelectPicker
                container={props.container}
                disabled={props.disabled}
                placeholder="Dial Code"
                data={data}
                value={props.countryflag}
                onSelect={(_, item) => props.onCountryChange({ iso2: item.value, name: item.name, dialCode: item.dialCode })}
                // renderValue={(_, item) => item?.code || ""}
                renderValue={(_, item) => {
                    return <div className="d-flex align-items-center gap-5">
                        <div className="my-auto country-flag-icon" dangerouslySetInnerHTML={{ __html: flagIcons[item.flag] }}></div>
                        <div className="my-auto text-14">+{item.dialCode}</div>
                    </div>
                }}
                id={props.id || ''}
                placement={"bottomStart"}
                className="select-flag"
                preventOverflow={true}
                containerPadding={0}
                // style={{ width: 50 }}
            />
        </div>
        <Input
            disabled={props.disabled}
            className={"phone-number-input " + (props.inputClassName || '')}
            placeholder={props.placeholder || "Enter mobile number1"}
            // pattern={props.pattern}
            value={props.inputValue}
            onChange={(_, event) => props.onInputChange(event)}
            onBlur={props.onPhoneNumberBlur}
            id={props.id || ''}
            inputMode="numeric"
            pattern="[0-9]*"
            type="tel"
            style={{ paddingLeft: '0px !important' }}
        />
    </div>
};

export default TelephoneInput;